jQuery(document).ready(function ($) {
  function smoothScrollToElementDiv(el, speed, top) {
    var speed = speed || 800;
    var top = top || 60;
    var elementToScrollToID = $(el);
    $("html, body").animate(
      {
        scrollTop: $(elementToScrollToID).offset().top - top,
      },
      speed
    );
  }

  var $accordion = $(".c-accordion");
  var $accordionItem = $(".c-accordion__item");
  var $accordionTitle = $(".c-accordion__title");
  var $accordionContents = $(".c-accordion__item-content");

  // Add class "is-active" to first element
  $(".c-accordion > .c-accordion__item:first-child").addClass("is-active");
  // (Optional) Active an item if it has the class "is-active"
  $(".c-accordion > .c-accordion__item.is-active")
    .children(".c-accordion__item-content")
    .slideDown();

  $accordionTitle.click(function (e) {
    e.preventDefault();
    var timeoutID;
    var $this = $(this);

    if ($(".c-accordion__item.scrollup").length) {
      smoothScrollToElementDiv($this, 300, 100);
      //console.log('yes yes')
    }

    // Cancel other parents
    $(this)
      .parent()
      .siblings(".c-accordion__item")
      .removeClass("is-active")
      .children(".c-accordion__item-content")
      .slideUp();

    // Toggle the item
    $this
      .parent()
      .toggleClass("is-active")
      .children(".c-accordion__item-content")
      .slideToggle("ease-out", function () {
        // when complete smooth scroll to the top of the item
        if ($(".c-accordion__item.scrollup").length) {
          smoothScrollToElementDiv($this, 300, 100);
          //console.log('yes yes')
        }
      });
  });
});
